import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { IGeneralDentalReferral, IGeneralDentalReferralSearchParams, IGeneralDentalReferralStatus } from "../models/IGeneralDentalReferral";
import { objectToQueryString } from "../helpers/ApiHelper";
import { ICareProvider } from "../models/ICareProvider";

export class GeneralDentalReferralSearchApi extends ApiClient {

    constructor(auth: AuthContextModel) {
        super(auth);
    }

    searchGeneralDentalReferrals(searchParams: IGeneralDentalReferralSearchParams, exportToExcel: boolean, success?: (referrals: IPaginatedResponse<IGeneralDentalReferral[]>) => void, fileName?: string, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        if (exportToExcel) {
            this.getFile(`${Utils.LIB_API_BASE_URL}/generalDentalReferralSearch?${queryString}&exportToExcel=true`, fileName, undefined, error, final)
        }
        if (success) {
            this.getPaginated(`${Utils.LIB_API_BASE_URL}/generalDentalReferralSearch?${queryString}`, success, error, final);
        }
    }

    getGeneralDentalReferralStatuses(success: (data: IGeneralDentalReferralStatus[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/generalDentalReferralSearch/statuses`, success, error, final);
    }

    getReferrerCareProviders(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/generalDentalReferralSearch/referrerCareProviders`, success, error, final);
    }

    getReferrerCareProvidersByUmbrellaOrganisationId(umbrellaOrganisationId: number, success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider[]>(`${Utils.LIB_API_BASE_URL}/generalDentalReferralSearch/referrerCareProvidersByUmbrellaOrganisationId/${umbrellaOrganisationId}`, success, error, final);
    }

    getReferrerUmbrellaOrganisations(success: (umbrellaOrganisations: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/generalDentalReferralSearch/referrerUmbrellaOrganisations`, success, error, final);
    }

    getRecipientCareProviders(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/generalDentalReferralSearch/recipientCareProviders`, success, error, final);
    }

    getRecipientCareProvidersByUmbrellaOrganisationId(umbrellaOrganisationId: number, success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider[]>(`${Utils.LIB_API_BASE_URL}/generalDentalReferralSearch/recipientCareProvidersByUmbrellaOrganisationId/${umbrellaOrganisationId}`, success, error, final);
    }

    getRecipientUmbrellaOrganisations(success: (UmbrellaOrganisations: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/generalDentalReferralSearch/recipientUmbrellaOrganisations`, success, error, final);
    }
}